import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IForgotPassword } from 'src/app/core/interfaces/login/forgotpassword.interface';
import { LoginService } from 'src/app/core/services/login/login.service';
import { ServersideAlertService } from 'src/app/core/services/onboarding/serverside-alert.service';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
})
export class ForgotpasswordComponent implements OnInit, OnDestroy {
  headerText = 'Reset Password';
  emailText = 'Email';
  sendbtnTxt = 'Send';
  backText = 'Login';
  backUrl = 'OnBoarding/Login/Login';
  form: FormGroup;
  forgotPasswordDiv = true;
  forgotPasswordSuccessDiv = false;
  forgotPasswordErrorDiv = false;
  forgetpasswordSuccssesMessage: string;
  forgetpasswordErrorMessage: string;
  subscriptions: Subscription[] = [];
  isLoad: boolean;

  constructor(
    private fb: FormBuilder,
    private ssas: ServersideAlertService,
    private lgs: LoginService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators['required'], Validators.email]],
    });
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  async resetPassword() {
    if (this.form.valid) {
      const payload: IForgotPassword = {
        Email: this.form.get('email')?.value ?? '',
      };
      const res = await this.lgs.forgotPassword(payload);
      if (res.success == true) {
        this.forgotPasswordDiv = false;
        this.forgotPasswordSuccessDiv = true;
        this.forgetpasswordSuccssesMessage = res.message;
      } else {
        this.forgotPasswordDiv = false;
        this.forgotPasswordErrorDiv = true;
        this.forgetpasswordErrorMessage = res.message;
      }
      this.isLoad = false;
    } else {
      this.form.markAllAsTouched(); // mark all controls as touched to trigger validation
      this.isLoad = false;
    }
    this.isLoad = true;
  }
}
